import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../../styles/FooterStyle.css";
import Logo from "../../assets/images/footer/logo.jpg";
import axios from "../../axiosinstens";
import swal from "sweetalert";

function Footer() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [newsletterEmail, setNewsletterEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    const organizerData = localStorage.getItem("organizer");
    if (organizerData) {
      setIsLoggedIn(true);
    }
  }, []);

  const handleNewsletterSubmit = async () => {
    if (!newsletterEmail || !/\S+@\S+\.\S+/.test(newsletterEmail)) {
      swal("Error", "Please enter a valid email address", "error");
      return;
    }

    setSubmitting(true);
    try {
      await axios.post("submit-email", {
        email: newsletterEmail
      });
      swal("Success", "Subscribed successfully!", "success")
      setNewsletterEmail("");
    } catch (error) {
      console.error("Subscription failed:", error);
      swal("Error", "Subscription failed. Please try again.", "error");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className="footer">
      <div className="container_row">
        <div className="row_footer">
          <div className="footercol1">
            <div className="footerlogo">
              <Link to="/" className="logo">
                <img src={Logo} alt="Logo" />
              </Link>
            </div>

            {/* Newsletter Section */}
            <div className="newsletter">
              <h4>Join our email list to be notified of new events</h4>
              <input
              className="newsletterinput"
                type="email"
                placeholder="Enter your email"
                value={newsletterEmail}
                onChange={(e) => setNewsletterEmail(e.target.value)}
              />
              <button
                onClick={handleNewsletterSubmit}
                disabled={submitting}
                className="newsletterbtn"
              >
                {submitting ? "Submitting..." : "Subscribe"}
              </button>
            </div>
          </div>

          <div className="footercol2">
            <div className="footline">
              <h4>Link</h4>
              <div className="footersec">
                <Link to="/">Home</Link>
              </div>
              <div className="footersec">
                <Link to="/about-us">About</Link>
              </div>
              <div className="footersec">
                <Link to="/events">Events</Link>
              </div>
              <div className="footersec">
                <Link to="/contact">Contact Us</Link>
              </div>
              <div className="footersec">
                <Link to={isLoggedIn ? "/seminar" : "/login"}>
                  Host A Seminar
                </Link>
              </div>
            </div>
          </div>

          <div className="footercol3">
            <h4>Contact Us</h4>
            <div className="footlines">
              <div className="footersec">
                <a href="tel:855-454-2448">855-454-2448</a>
              </div>
              <div className="footersec">
                <a href="mailto:host@spectacularseminars.com">
                  host@spectacularseminars.com
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="row_footer2">
          <div className="privacy">
            <a href="/privacy">Privacy</a>
          </div>
          <div className="privacyone">
            <a href="/termsandconditions">Terms and Conditions</a>
          </div>
        </div>

        <div className="row_footer3">
          <div className="privac">
            <p>
              <a
                href="https://v1technologies.co.uk/web-development"
                target="_blank"
                rel="noopener noreferrer"
              >
                Website Design
              </a>{" "}
              :{" "}
              <a
                href="https://v1technologies.co.uk/"
                target="_blank"
                rel="noopener noreferrer"
              >
                V1 Technologies
              </a>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Footer;
